var React = require('react');

function SplashBot (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0H1449C1215.21 62.6997 142.788 180.821 0 237V0Z","fill":"#0C75B0"}));
}

SplashBot.defaultProps = {"viewBox":"0 0 1449 237","fill":"none"};

module.exports = SplashBot;

SplashBot.default = SplashBot;
